import React from "react"
import PropTypes from "prop-types"
import TextInput from "./TextInput"
import { Col, Row } from "reactstrap"

export default function TextInputWithLabel({
  value,
  onChange,
  name,
  placeholder,
  type,
  label,
  readOnly,
  className = "",
  isTextArea = false,
  pattern,
}) {
  return (
    <>
      <label className="form-label">{label}</label>
      {isTextArea ? (
        <textarea
          className={`form-control ${className}`}
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          readOnly={readOnly}
        />
      ) : (
        <TextInput
          className={className}
          name={name}
          placeholder={placeholder}
          type={type}
          onChange={onChange}
          value={value}
          readOnly={readOnly}
          pattern={pattern}
        />
      )}
    </>
  )
}

TextInputWithLabel.defaultProps = {
  label: "",
  value: "",
  onChange: null,
  placeholder: "",
  type: "text",
  readOnly: false,
}

TextInputWithLabel.propTypes = {
  value: PropTypes.string || PropTypes.number,
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
}
